import { ServiceRequestStatus } from '@prisma/client';

export const API_BASE_PATH = 'service-request';

export const SERVICE_REQUESTS_SERVER_PAGE_LIMIT = 100;

export const ServiceRequestStatusBadgeVariant = {
  [ServiceRequestStatus.NOT_STARTED]: 'gray',
  [ServiceRequestStatus.IN_PROGRESS]: 'warning',
  [ServiceRequestStatus.COMPLETED]: 'success',
  [ServiceRequestStatus.ARCHIVED]: 'gray',
} as const satisfies Record<ServiceRequestStatus, string>;
